import React from 'react';
import I18n from 'i18n-js';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { RCBanner, RCText, useMediaQuery } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import PiggyBank from '../../../images/piggy-bank.svg';
// import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
// import { REVERB_PAYMENTS_EXPANSION_ARTICLE_ID } from '@reverbdotcom/commons/src/constants';

export default function ReverbPaymentsExpansionEarningsBanner() {
  // TODO: Update this with the correct article URL once the article is published
  const articleUrl = '#'; // useHelpCenterArticleUrl(REVERB_PAYMENTS_EXPANSION_ARTICLE_ID);
  const isDesktop = useMediaQuery('desktop');

  return (
    <div className="reverb-payments-expansion-earnings-banner">
      <RCBanner
        title={I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.title')}
        image={PiggyBank}
        content={
          <>
            <I18N text="discovery.reverbPaymentsExpansionEarningsBanner.subtitle">
              <a href={articleUrl} target="_blank" className="text-link" rel="noopener noreferrer">
                {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.learnMore')}
              </a>
            </I18N>
            {isDesktop && (
              <RCText.Fine>
                {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.finePrint')}
              </RCText.Fine>
            )}
          </>
        }
        cta={
          <CoreLink to={Paths.shopPoliciesEdit.expand({})} target="_blank" rel="noopener noreferrer">
            {I18n.t('discovery.reverbPaymentsExpansionEarningsBanner.updatePayoutSettings')}
          </CoreLink>
        }
        theme="plain"
      />
    </div>
  );
}
